var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"text-center pt-12"},[_vm._v(" CRM Priser ")]),_c('Pricetable'),_c('Quote',{attrs:{"color":"light-blue","text":"Mest prisvärda CRM systemet på marknaden","subtext":"- Sarah, Göteborg"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }